import React, { useEffect, useState } from 'react';
import axios from '../../util/Api';
import Table from '../../components/Table/Basic';
import Date from '../../components/Formatter/Date';
import DeleteButton from './DeleteButton';

const History = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [histories, setHistories] = useState([]);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    fetchTrainingHistories();
  }, [id]);

  const fetchTrainingHistories = () => {
    setLoading(true);
    const url = `/training/list?passport=${id}`;
    axios.get(url).then(resp => {
      setHistories(resp.data.training);
      setTotal(resp.data.total);
      setLoading(false);
    }).catch(err => {});
  }

  const columns = [
    {
      title: "Divisi",
      key: 'division',
      render: record => record.current_project.division.label
    },
    {
      title: "Proyek",
      key: 'project',
      render: record => record.current_project.project.name
    },
    {
      title: "Perusahaan",
      key: "vendor",
      render: record => record.passport.vendor.name,
    },
    {
      title: "Tanggal Training",
      key: 'start_date',
      render: record => <Date value={record.date}/>
    },
    {
      title: "Berlaku Sampai",
      key: 'expiry_date',
      render: record => <Date value={record.expiry_date}/>
    },
    {
      title: "Jenis Training",
      key: 'type',
      render: record => record.type.label
    },
    {
      title: "Bidang Training",
      key: 'category',
      render: record => record.field.category.name
    },
    {
      title: "Judul Training",
      key: 'title',
      render: record => record.field.title
    },
    {
      title: "Status",
      key: 'status',
      render: record => record.status.label
    },
    {
      title: "",
      key: 'action',
      render: record => {
        return (
          <>
            <DeleteButton id={record.id}/>
          </>
        );
      }
    }
  ];

  return (
    <>
      <h4 className="gx-mb-3">Riwayat Data Training</h4>
      {loading ? "Sedang memuat..." : (
        <>
          <Table
            columns={columns}
            dataSource={histories}
            loading={loading}
            total={total}
            showSorterTooltip
            pathname="/training"
            sticky
          />
        </>
      )}
    </>
  );
}

export default History;